import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import shiftup2 from "../../Assets/Projects/shiftup2.gif";
import travis_county from "../../Assets/Projects/Travis_County.png";
import austin_city from "../../Assets/Projects/Austin_City.png";
import san_marcos from "../../Assets/Projects/San_Marcos_Library.png";
import crimson_ark from "../../Assets/Projects/crimson_ark.png";
import urban_alchemy from "../../Assets/Projects/Urban-Alchemy.jpg"
import code_soil from "../../Assets/Projects/code&soil.png"
import montopolis from "../../Assets/Projects/Montopolis.jpg"
import unrulr from "../../Assets/Projects/Unrulr.png"
import insight from "../../Assets/Projects/Insight.png"
import mido from "../../Assets/Projects/Mido.png"
import techkids from "../../Assets/Projects/TechKidsUltd.png"
import ldg from "../../Assets/Projects/LDG.png"
import centro from "../../Assets/Projects/Centro.png"
import assist from "../../Assets/Projects/Assist.png"
import favrhood from "../../Assets/Projects/favrhood_logo1.png"


function Toolstack() {
  const { t } = useTranslation();

  const logoAlt = (name) => t("aboutPartners.a11y.partnerLogoAlt", { name });

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
      <img src={travis_county} alt={logoAlt("Travis County")} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <img src={austin_city} alt={logoAlt("City of Austin")} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <img src={shiftup2} alt={logoAlt("ShiftUp")} className="img-fluid" />      
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <img src={san_marcos} alt={logoAlt("San Marcos Public Library")} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        {t("aboutPartners.partnerNames.crimsonArkStudio")}
        <img src={crimson_ark} alt={logoAlt(t("aboutPartners.partnerNames.crimsonArkStudio"))} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">       
        <img src={favrhood} alt={logoAlt("Favrhood")} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={urban_alchemy} alt={logoAlt("Urban Alchemy")} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={code_soil} alt={logoAlt("Code & Soil")} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={montopolis} alt={logoAlt("Montopolis")} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={unrulr} alt={logoAlt("Unrulr")} className="img-fluid" />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <img src={insight} alt={logoAlt("Insight")} className="img-fluid" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={mido} alt={logoAlt("Mido")} className="img-fluid" />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <img src={techkids} alt={logoAlt("TechKidsUltd")} className="img-fluid" />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <img src={ldg} alt={logoAlt("LDG")} className="img-fluid" />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <img src={centro} alt={logoAlt("Centro")} className="img-fluid" />
      </Col>
          <Col xs={4} md={2} className="tech-icons">
        <img src={assist} alt={logoAlt("Assist")} className="img-fluid" />
      </Col>
    </Row>
  );
}

export default Toolstack;
